import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
  Badge,
} from "reactstrap";
import Select from "react-select";
import Tippy from "@tippyjs/react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { api } from "../../../../api";
import Cookies from "js-cookie";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

const Project1 = () => {
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [clientForm, setClientForm] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [flippedStates, setFlippedStates] = useState({});
  const [tasks, setTasks] = useState([]);
  const [multiTask, setMultiTask] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addproject, setaddproject] = useState({
    p_name: "",
    p_budget: "",
    engineers: [],
    start_date: "",
    end_date: "",
    departments: [],
    p_location: "",
    p_description: "",
    files: [],
    BOQ: null,
    BOM: null,
    p_m_id: "",
    emp_id: Cookies.get("token"),
  });
  const [selectedSiteManagers, setSelectedSiteManagers] = useState([]);
  const [selecteddepartment, setselecteddepartment] = useState([]);
  const [members, setmembers] = useState();
  const [projectmanager, setprojectmanager] = useState([]);
  const [department, setdepartment] = useState();
  const [BOQ, setBOQ] = useState('No File Selected');
  const [BOM, setBOM] = useState('No File Selected');
  const [clientName, setclientName] = useState([]);
  const [deleteConfirmationEmployeeId, setDeleteConfirmationEmployeeId] = useState(null);
  const fileInputRef = useRef(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [roleConfig, setRoleConfig] = useState({});

  const company_id = Cookies.get('company_id');
  const emp_id = Cookies.get('emp_id');

  // Function to get dynamic role names
  const getRoleName = (defaultRole) => {
    return roleConfig[defaultRole] || defaultRole;
  };

  // Function to fetch role configuration
  const fetchRoleConfig = async () => {
    try {
      const response = await api.get(`roleConfig.php?company_id=${company_id}`);
      const roleMap = {};
      if (Array.isArray(response.data)) {
        response.data.forEach(role => {
          // Map default role names to their resolved names
          roleMap[role.default_role_name] = role.resolved_role_name;
        });
      }
      setRoleConfig(roleMap);
      console.log("Role config loaded:", roleMap);
    } catch (error) {
      console.error("Error fetching role config:", error);
      // Fallback to default role names
      setRoleConfig({
        'Project Manager': 'Project Manager',
        'Project Engineer': 'Project Engineer',
        'Site Manager': 'Site Manager',
        'Site Supervisor': 'Site Supervisor'
      });
    }
  };

  const handleClick = (id) => {
    setFlippedStates((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const toggleAddClientModal = () =>
    setShowAddClientModal((prevState) => !prevState);

  const handleAddClient = () => {
    toggleAddClientModal();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`);
        setTasks(response.data);
        const response2 = await api.get(`viewTask.php?id=${emp_id}&company_id=${company_id}`);
        setMultiTask(response2.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const employees = tasks;

  useEffect(() => {
    const filtered = Array.isArray(tasks)
      ? tasks.filter((task) =>
          (task.p_name || '').toLowerCase().includes(searchQuery.toLowerCase())
        )
      : [];
    setFilteredTasks(filtered);
  }, [searchQuery, tasks]);

  const toggleViewMoreModal = (employee) => {
    setSelectedEmployee(employee);
  };

  const renderViewMoreModal = () => {
    if (!selectedEmployee) return null;

    return (
      <Modal isOpen={true} toggle={() => toggleViewMoreModal(null)}>
        <ModalHeader toggle={() => toggleViewMoreModal(null)}>
          Employee View
        </ModalHeader>
        <ModalBody style={{ justifyContent: "center", textAlign: "center" }}>
          {selectedEmployee && selectedEmployee.image_filename ? (
            <img
              alt="Profile"
              className="rounded-circle"
              src={getImagePath(selectedEmployee.image_filename)}
              onError={e => { e.target.onerror = null; e.target.src = getImagePath('default-profile.png'); }}
              style={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                objectFit: 'cover',
                display: 'block',
                margin: '0 auto 10px auto',
                boxShadow: '0 0 10px rgba(0,0,0,0.15)'
              }}
            />
          ) : null}
          <p>
            {" "}
            <b>Project Name :</b> {selectedEmployee.p_name}
          </p>
          <p>
            {" "}
            <b>Project Status :</b> {selectedEmployee.p_status}
          </p>
          <p>
            <b>Project Budget :</b> {selectedEmployee.p_budget}
          </p>
          <p>
            <b>Site Managers :</b> {selectedEmployee.site_manager_names}
          </p>
          <p>
            <b>Project location :</b> {selectedEmployee.p_location}
          </p>
          <p>
            <b>Start Date:</b> {selectedEmployee.start_date}
          </p>
          <p>
            <b>End Date :</b> {selectedEmployee.end_date}
          </p>
          <p>
            <b>Contract details :</b>{" "}
            {selectedEmployee.p_description.replace(/<[^>]*>?/gm, "")} {" "}
          </p>
          <p>
            <b>Departments :</b> {selectedEmployee.department_names}
          </p>
          <p>
            <b>Files :</b>{" "}
            <a href={`../../../images/${selectedEmployee.files}`} download>
              {selectedEmployee.files}
            </a>
          </p>
        </ModalBody>
      </Modal>
    );
  };

  const toggleDeleteConfirmationModal = (employeeId) => {
    setDeleteConfirmationEmployeeId(
      employeeId === deleteConfirmationEmployeeId ? null : employeeId
    );
  };

  const handleDropdownItemClick = (action, employeeId, employeeName) => {
    if (action === "Delete") {
      toggleDeleteConfirmationModal(employeeId);
    } else {
      console.log(`Clicked ${action}`);
    }
  };

  const handleDeleteConfirmation = (confirmed, employeeId) => {
    if (confirmed) {
      console.log(`Deleting employee with ID: ${employeeId}`);
      const fetchData = async () => {
        try {
          const response = await api.get(`deleteProject.php?id=${employeeId}&company_id=${company_id}`);
          console.log(response.data);
          window.location.reload();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
    toggleDeleteConfirmationModal(employeeId);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Validation for required fields
    if (!addproject.p_m_id || addproject.p_m_id === "") {
      alert(`Please select a ${getRoleName('Project Manager')}`);
      return;
    }
    if (!addproject.engineers || addproject.engineers.length === 0) {
      alert("Please select at least one Member");
      return;
    }
    if (!addproject.departments || addproject.departments.length === 0) {
      alert("Please select at least one Department");
      return;
    }
    if (!addproject.p_name || !addproject.p_budget || !addproject.start_date || !addproject.end_date || !addproject.p_location) {
      alert("Please fill all required fields");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("p_name", addproject.p_name);
    formDataToSend.append("p_budget", addproject.p_budget);
    // Join arrays as comma-separated strings for PHP
    formDataToSend.append("engineers", addproject.engineers.join(","));
    formDataToSend.append("departments", addproject.departments.join(","));
    formDataToSend.append("start_date", addproject.start_date);
    formDataToSend.append("end_date", addproject.end_date);
    formDataToSend.append("p_location", addproject.p_location);
    formDataToSend.append("p_description", addproject.p_description);
    if (addproject.files && addproject.files.length > 0) {
      for (let i = 0; i < addproject.files.length; i++) {
        formDataToSend.append("image[]", addproject.files[i]);
      }
    }
    formDataToSend.append("boq", addproject.BOQ);
    formDataToSend.append("bom", addproject.BOM);
    formDataToSend.append("p_m_id", addproject.p_m_id);
    formDataToSend.append("emp_id", emp_id);
    formDataToSend.append("company_id", company_id);
    formDataToSend.append("client_id", addproject.client_id);

    try {
      const response = await api.post(`addproject.php?company_id=${company_id}`, formDataToSend);
      setSuccessMessage('New Project Added Successfully!');
      setShowSuccessAlert(true);
    } catch (error) {
      console.error("Error submitting data:", error);
      setSuccessMessage('Error adding project. Please try again.');
      setShowSuccessAlert(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setaddproject((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(addproject);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        
        // Fetch role configuration first
        await fetchRoleConfig();
        
        const response = await api.get(`empGMdetails.php?company_id=${company_id}`);
        const response2 = await api.get(`empGMdetails.php?p_m=1&company_id=${company_id}`);
        const response3 = await api.get(`department.php?company_id=${company_id}`);

        const formattedData = Array.isArray(response.data)
          ? response.data.map((item) => ({
              value: item.emp_id,
              label: item.emp_name, // Backend already adds the role, so don't add it again
            }))
          : [];

        const formattedData2 = Array.isArray(response2.data)
          ? response2.data.map((item) => ({
              value: item.emp_id,
              label: item.emp_name,
            }))
          : [];

        const formattedData3 = Array.isArray(response3.data)
          ? response3.data.map((item) => ({
              value: item.d_id,
              label: item.dept_name,
            }))
          : [];

        setmembers(formattedData);
        setprojectmanager(formattedData2);
        setdepartment(formattedData3);
        console.log("Project managers response:", response2.data);
        console.log("Project managers formatted:", formattedData2);
        console.log("Members response:", response.data);
        console.log("Departments response:", response3.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        console.error("Error details:", error.response?.data || error.message);
        setprojectmanager([]);
        setmembers([]);
        setdepartment([]);
      }
    };
    fetchData();
  }, []);

  const handleSiteManagerSelectChange = (selectedOptions) => {
    setSelectedSiteManagers(selectedOptions);
    setaddproject((prevState) => ({
      ...prevState,
      engineers: selectedOptions.map((option) => option.value),
    }));
    console.log(addproject);
  };

  const handledepartmentSelectChange = (selectedOptions) => {
    setselecteddepartment(selectedOptions);
    setaddproject((prevState) => ({
      ...prevState,
      departments: selectedOptions.map((option) => option.value),
    }));
    console.log(addproject);
  };

  const handleBOQFileChange = (e) => {
    const file = e.target.files[0];
    setBOQ(file.name);
    setaddproject((prevState) => ({
      ...prevState,
      BOQ: file,
    }));
    console.log(addproject);
  };

  const handleBOMFileChange = (e) => {
    const file = e.target.files[0];
    setBOM(file.name);
    setaddproject((prevState) => ({
      ...prevState,
      BOM: file,
    }));
    console.log(addproject);
  };

  const handleAddFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    setaddproject((prevState) => ({
      ...prevState,
      files: [...prevState.files, ...files],
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`clientGM.php?company_id=${company_id}`);
        setclientName(Array.isArray(response.data) ? response.data : []);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setclientName([]);
      }
    };
    fetchData();
  }, []);

  const getImagePath = (imageName) => {
    if (!imageName) return '/images/default-profile.png';
    return `/images/${imageName}`;
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="mb-5">
            <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
              <h1>Project Details</h1>
            </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex text-right">
              <Form className="navbar-search  form-inline ml-5 d-none d-md-flex ml-lg-auto ">
                <FormGroup className="mb-0 ml-6">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" style={{color: 'black'}}/>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search Project"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              </Form>
              <Col className="order-xl-2 mb-5 mb-xl-0 ">
                <Button onClick={handleAddClient} style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}>Add Project</Button>
              </Col>
            </Col>
          </Row>
        </Container>

        <Container fluid>
          <Row>
            {filteredTasks && Array.isArray(filteredTasks) ? (
              filteredTasks.map((employee) => (
                <Col className="mb-4" lg="6" xl="3" key={employee.id}>
                  <Card
                    onClick={() => handleClick(employee.p_id)}
                    className="card-stats mb-4 mb-xl-0 "
                    style={{
                      borderRadius: "15px",
                      position: "relative",
                      transformStyle: "preserve-3d",
                      transition: "transform 0.6s",
                      transform: flippedStates[employee.p_id]
                        ? "rotateY(180deg)"
                        : "rotateY(0deg)",
                      cursor: "pointer",
                      height: "300px",
                      zIndex: 0,
                      background: "rgb(255,255,255)",
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff'
                     
                    }}
                  >
                    <CardBody
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className=" justify-content-center"
                        style={{ alignItems: "center", textAlign: "center" }}
                      >
                        <div>
                          <CardTitle className="h4 mb-0">
                            <h1>{employee.p_name}</h1>
                          </CardTitle>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <CircularProgressbar
                          value={employee.project_progress}
                          text={`${employee.project_progress}%`}
                          styles={buildStyles({
                            textColor: "blue",
                            pathColor: "#007bff",
                            trailColor: "#eee",
                          })}
                        />
                      </div>
                      {employee && employee.project_manager_id === 0 && (
                        <Badge color='warning' className="text-center">Pending</Badge>
                      )}
                    </CardBody>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                        background:'white',
                        borderRadius: "15px",
                        zIndex: "1",
                      }}
                    >
                      <CardBody className=" pt-md-4 ">
                        <div className="text-center">
                          <h3>{employee.p_name}</h3>
                          <h3>{employee.p_budget}</h3>
                          <h3>{employee.p_location}</h3>
                          <h3>{employee.end_date}</h3>
                          <div className="avatar-group d-flex justify-content-center">
                            {employee.profile.images.map((image, index) => (
                              <div
                                className="avatar-group "
                                style={{ height: "40px", width: "25px" }}
                                key={index}
                              >
                                <button
                                  className="avatar avatar-sm "
                                  id={`tooltip-${employee.p_id}-${index}`}
                                  onClick={(e) => e.preventDefault()}
                                  style={{ border: 'none', background: 'none', padding: 0 }}
                                >
                                  <img
                                    alt={`Profile ${index}`}
                                    className="rounded-circle"
                                    style={{ height: "35px", width: "35px" }}
                                    src={getImagePath(image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = getImagePath('default-profile.png');
                                    }}
                                  />
                                </button>
                                <UncontrolledTooltip
                                  delay={0}
                                  target={`tooltip-${employee.p_id}-${index}`}
                                >
                                  {employee.profile.full_names[index]}
                                </UncontrolledTooltip>
                              </div>
                            ))}
                          </div>
                          <hr className="my-4 " />
                          <div className="" style={{}}>
                            <Link
                              to={`/general-admin/general-management/editproject1/${employee.p_id}`}
                              style={{ color: "Black" }}
                            >
                              <Tippy content="Edit">
                                <i
                                  onClick={() => console.log("Edit clicked")}
                                  className="fas fa-edit"
                                  style={{ marginRight: "10px" }}
                                ></i>
                              </Tippy>
                            </Link>
                            <Link
                              to={`/general-admin/general-management/viewproject1/${employee.p_id}`}
                              style={{ color: "Black" }}
                              onClick={() => toggleViewMoreModal(employee)}
                            >
                              <Tippy content="View">
                                <i
                                  className="fa-solid fa-eye"
                                  style={{ marginRight: "10px" }}
                                ></i>
                              </Tippy>
                            </Link>
                            <button
                              onClick={() =>
                                handleDropdownItemClick(
                                  "Delete",
                                  employee.p_id,
                                  employee.p_name
                                )
                              }
                              style={{ border: 'none', background: 'none', padding: 0 }}
                            >
                              <Tippy content="Delete">
                                <i className="fa fa-trash"></i>
                              </Tippy>
                            </button>
                          </div>
                        </div>
                      </CardBody>
                    </div>
                  </Card>
                </Col>
              ))
            ) : (
              <h3>No Project available</h3>
            )}
          </Row>
        </Container>
      </div>

      {employees &&
        Array.isArray(employees) &&
        employees.length > 0 &&
        employees.map((employee) => (
          <Modal
            key={employee.p_id}
            isOpen={deleteConfirmationEmployeeId === employee.p_id}
            toggle={() => toggleDeleteConfirmationModal(employee.p_id)}
          >
            <ModalHeader
              toggle={() => toggleDeleteConfirmationModal(employee.p_id)}
            >
              Confirm Delete
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete {employee.client_name}?
              <div className="mt-3 text-right">
                <form>
                  <Button
                    color="danger"
                    onClick={() =>
                      handleDeleteConfirmation(true, employee.p_id)
                    }
                  >{`Yes, delete ${employee.p_name}`}</Button>{" "}
                </form>
                <Button
                  color="secondary"
                  onClick={() => handleDeleteConfirmation(false, employee.p_id)}
                >
                  No
                </Button>
              </div>
            </ModalBody>
          </Modal>
        ))}

      {/* Add Client Modal */}
      <Modal isOpen={showAddClientModal} toggle={toggleAddClientModal}>
        <ModalHeader toggle={toggleAddClientModal} >Add Project</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleFormSubmit} encType="multipart/form-data">
            <Row>
              <Col md={12}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-status">
                    Client Name<span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-status"
                    type="select"
                    name="client_id"
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Client Name</option>
                    {Array.isArray(clientName) && clientName.length > 0 ? (
                      clientName.map((option) => (
                        <option key={option.client_id} value={option.client_id}>
                          {option.client_name}
                        </option>
                      ))
                    ) : (
                      <option value="">No clients available</option>
                    )}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-budget">
                   Project Name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-budget"
                    type="text"
                    name="p_name"
                    onChange={handleInputChange}
                    placeholder="Project Name"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-budget">
                    Project Budget <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-budget"
                    type="number"
                    name="p_budget"
                    onChange={handleInputChange}
                    placeholder="Project Budget"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-status">
                    Select {getRoleName('Project Manager')}<span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-status"
                    type="select"
                    name="p_m_id"
                    onChange={handleInputChange}
                  >
                    <option value="">Select </option>
                    {projectmanager.length > 0 ? (
                      projectmanager.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))
                    ) : (
                      <option value="">No {getRoleName('Project Manager')}s</option>
                    )}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-site-manager"
                  >
                    Select Department's
                  </label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isMulti
                    value={selecteddepartment}
                    onChange={handledepartmentSelectChange}
                    options={department}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-site-manager"
                  >
                    Select Members<span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isMulti
                    value={selectedSiteManagers}
                    onChange={handleSiteManagerSelectChange}
                    options={members}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-starting"
                  >
                    Project Starting Date<span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-starting"
                    type="date"
                    name="start_date"
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-ending">
                    Project Ending Date<span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-ending"
                    type="date"
                    name="end_date"
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-location"
                  >
                    Location<span style={{ color: 'red' }}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-location"
                    type="text"
                    name="p_location"
                    onChange={handleInputChange}
                    placeholder="Location"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-description"
                  >
                    Project Description
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={addproject.p_description}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setaddproject((prevState) => ({
                        ...prevState,
                        p_description: data,
                      }));
                    }}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-file">
                    Upload BOQ File
                  </label>
                  <div className="custom-file-input-wrapper">
                    <label style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} className="btn btn-success p-1 custom-file-input-label" htmlFor="input-BOQ-file">
                      Choose File
                    </label>
                    <Input
                      type="file"
                      id="input-BOQ-file"
                      name="BOQ"
                      style={{ display: 'none' }}
                      onChange={handleBOQFileChange}
                    />
                    <h5>{BOQ}</h5>
                  </div>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label  className="form-control-label" htmlFor="input-file">
                    Upload BOM File
                  </label>
                  <div className="custom-file-input-wrapper">
                    <label style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} className="btn btn-success p-1 custom-file-input-label" htmlFor="input-BOM-file">
                      Choose File
                    </label>
                    <Input
                      type="file"
                      id="input-BOM-file"
                      name="BOM"
                      style={{ display: 'none' }}
                      onChange={handleBOMFileChange}
                    />
                      <h5>{BOM}</h5>
                  </div>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <label>Upload Documents:</label>
                  <div>
                    <Button
                      type="button"
                      style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                      onClick={handleAddFileClick}
                      className="p-1"
                    >
                      Upload Documents
                    </Button>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      multiple
                    />
                    {addproject.files.length > 0 ? (
                      addproject.files.map((file, index) => (
                        <h5 className="mt-1 mt-0" key={index}>File {index + 1} : {file.name}</h5>
                      ))
                    ) : (
                      <h5>No Documents Selected</h5>
                    )}

                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{ textAlign: "center" }}>
                <Button style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {renderViewMoreModal()}

      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                window.location.reload();
              }}
            >OK</Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Project1;